import { useQuery } from "@tanstack/react-query";
import { getBrandById } from "../../api/apiBrands";
import i18next from "i18next";

/**
 * Hook لجلب بيانات علامة تجارية واحدة
 * @param {number|string} id - Brand ID
 */
export function useGetBrandById(id) {
    const {
        data,
        error,
        isLoading,
        refetch
    } = useQuery({
        queryKey: ["brand", id, i18next.language],
        queryFn: () => getBrandById(id),
        enabled: !!id,
        retry: false,
    });

    return {
        brand: data?.data || null,
        error,
        isLoading,
        refetch
    };
}
